import { http } from "./http";

export const electronicInvoicingApi = {
  connectAruba: (token: string | null, body: any) =>
    http<any>("/electronic-invoicing/aruba/connect", { method: "POST", body: JSON.stringify(body) }, token),

  getArubaStatus: (token: string | null) =>
    http<any>("/electronic-invoicing/aruba/status", { method: "GET" }, token),

  getSyncLogs: (token: string | null) =>
    http<any[]>("/electronic-invoicing/sync-logs", { method: "GET" }, token),

  createInvoice: (token: string | null, body: any) =>
    http<any>("/invoices", { method: "POST", body: JSON.stringify(body) }, token),

  listInvoices: (token: string | null) =>
    http<any[]>("/invoices", { method: "GET" }, token),

  getInvoice: (token: string | null, id: string) =>
    http<any>(`/invoices/${encodeURIComponent(id)}`, { method: "GET" }, token),

  listSentInvoices: (token: string | null) =>
    http<any[]>("/electronic-invoicing/aruba/sent", { method: "GET" }, token),

  listReceivedInvoices: (token: string | null) =>
    http<any[]>("/electronic-invoicing/aruba/received", { method: "GET" }, token),

  listPassiveReceivedInvoices: (token: string | null) =>
    http<any[]>("/received-invoices", { method: "GET" }, token),

  getPassiveReceivedInvoice: (token: string | null, id: string) =>
    http<any>(`/received-invoices/${encodeURIComponent(id)}`, { method: "GET" }, token),

  generateXml: (token: string | null, id: string) =>
    http<any>(`/invoices/${encodeURIComponent(id)}/generate-xml`, { method: "POST" }, token),

  sendInvoice: (token: string | null, id: string) =>
    http<any>("/electronic-invoicing/aruba/send", { method: "POST", body: JSON.stringify({ invoiceId: id }) }, token),

  listInvoiceNotifications: (token: string | null, id: string) =>
    http<any[]>(`/invoices/${encodeURIComponent(id)}/notifications`, { method: "GET" }, token),
};
